import React from 'react';
import {Field, Fields, reduxForm, actionTypes} from 'redux-form';
import FileUpload from '../files/FileUpload';
import SubmitButton from '../common/SubmitButton';
import ValidatedWrappedInputField from "../company/information/ValidatedWrappedInputField";
import PortalSelect from "./PortalSelect";
import {PortalContactValidator} from "./PortalContactValidator";
import ContactPersonPhoneInput from "../contact-person/ContactPersonPhoneInput";
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import afterSubmitFail from '../common/form/focusAfterSubmitFail';
import ResetButton from "../common/ResetButton";

class PortalContactForm extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        let imageSizeLimit = (MAX_IMAGE_SIZE > 1) ? MAX_IMAGE_SIZE - 1 : 1;

        return (
            <form onSubmit={this.props.handleSubmit} noValidate={true}>
                <Field
                    className="form-control"
                    name="name"
                    type="text"
                    component={ValidatedWrappedInputField}
                    label={this.props.intl.formatMessage(messages.name)}
                />
                <Field
                    className="form-control"
                    name="email"
                    type="email"
                    component={ValidatedWrappedInputField}
                    label={this.props.intl.formatMessage(messages.email)}
                />
                <Field
                    name="phone"
                    className="form-control"
                    type="tel"
                    label={this.props.intl.formatMessage(messages.phone)}
                    component={ContactPersonPhoneInput}
                />
                <Field
                    name="departmentId"
                    component={PortalSelect}
                    label={this.props.intl.formatMessage(messages.department)}
                    options={this.props.departments}
                    placeholder={this.props.intl.formatMessage(messages.select)}
                />
                <Field
                    name="portalId"
                    component={PortalSelect}
                    label={this.props.intl.formatMessage(messages.portal)}
                    options={this.props.portals}
                    placeholder={this.props.intl.formatMessage(messages.select)}
                />
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">
                        <b>{this.props.intl.formatMessage(messages.portraitPhoto)}</b>
                        <small className="form-text text-muted">{`${this.props.intl.formatMessage(messages.filesMaxSize)} ${imageSizeLimit} MB.`}</small>
                    </label>
                    <div className="col-sm-10">
                        <Fields
                            type="file"
                            names={[
                                'images',
                                'defaultImages',
                                'defaultImageIds',
                            ]}
                            component={FileUpload}
                            props={{
                                postUrl: 'api/privateV1/portal-contacts/validate-images',
                                maxFiles: 1,
                                type: 'image'
                            }}
                        />
                    </div>
                </div>
                <Field
                    className="form-control"
                    name="sorter"
                    type="number"
                    min="1"
                    component={ValidatedWrappedInputField}
                    label={this.props.intl.formatMessage(messages.order)}
                />
                <div className="form-group row">
                    <div className="col-sm-12">
                        <div className="offset-sm-2">
                            <SubmitButton isUpdate={this.props.isUpdate}/>
                            <ResetButton onClick={this.props.handleReset}/>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

PortalContactForm = reduxForm({
    form: 'portal-contact',
    validate: PortalContactValidator,
    onSubmitFail: afterSubmitFail
})(PortalContactForm);

export default injectIntl(PortalContactForm);


// WEBPACK FOOTER //
// ./web/src/components/portal-contact/PortalContactForm.jsx